/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const faggotryCommunityStyles: CommunityData = {
  code: "faggotry",
  name: "Faggotry",
  inviteCode: "fgtry21",
  thumbnail: "",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/fag-165`,
  socials: {
    instagramLink: "",
    soundcloudLink: "",
  },
  styles: {
    global: {
      counterColor: "#0A2B41",
      alternativeLogo: {
        src: "https://media.werz.at/community-assets/faggotry/web-logo.png",
        styles: "w-[108px] object-contain",
      },
      logo: {
        src: "https://media.werz.at/community-assets/faggotry/web-logo.png",
        styles: "w-[80px] object-contain",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#FF8DDE",
      asideStyles: "border-r !border-[#000000]",
      asideBg: "#FF8DDE",
      contentBg: "#FF8DDE",
      contentBoxShadow: "border border-[#000000]",
      bgDesktop: "https://media.werz.at/community-assets/faggotry/web-bg-desktop.jpg",
      bgMobile: "https://media.werz.at/community-assets/faggotry/web-bg-desktop.jpg",
      nonMemberBg: "https://media.werz.at/community-assets/faggotry/web-bg-desktop.jpg",
      mainFont: "font-['Exo']",
      primaryButton:
        "w-full sm:w-fit bg-[#FFB4E9] border-[1px] !px-6 !py-4 whitespace-nowrap font-['TestTiemposText-Regular'] !text-[#000000] text-[16px] leading-[24px] !border-[#000000]",
    },
    navigation: {
      sideBarSeparator: "",
      iconsColor: "#000000",
      separator: "border-[#000000] border-t",
      item: "!font-['TestTiemposText-Regular'] !text-[16px] !leading-[1] !py-4 flex items-center justify-center opacity-50 -ml-2",
      itemSelected: "!opacity-100",
    },
    communityLanding: {
      container: "!p-0 !m-0",
      emptyOrLoadingState: "!mx-4 sm:!mx-8 !font-['TestTiemposText-Regular'] !text-[12px]",
      titles:
        "!font-['TestTiemposText-Regular'] !text-[26px] uppercase !font-normal !mb-6 tracking-[0.04em]",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0",
        sectionTitle: "pl-4 sm:pl-8 !mb-4 !sm:mb-6 !tracking-[0.04em]",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] border border-[#000000] h-full overflow-hidden",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative",
          media: "w-full !aspect-square object-cover",
          placeholderMedia: "w-full h-full bg-gray-400",
          content: "flex flex-col p-4 bg-[#FF8DDE] border-t border-[#000000]",
          title: "font-['TestTiemposText-Regular'] text-[16px] uppercase leading-[1.2]",
          subtitle: "font-['TestTiemposText-Regular'] text-[12px] leading-[1] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 border-y border-[#000000]",
        sectionTitle: "pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] border border-[#000000] h-full overflow-hidden",
          mediaContainer:
            "flex-shrink-0 sm:!w-[228px] h-[256px] sm:!h-[128px] w-full aspect-square relative",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full h-full bg-gray-400",
          content: "p-4 bg-[#FF8DDE] border-t sm:border-t-0 sm:border-l border-[#000000]",
          title: "font-['TestTiemposText-Regular'] text-[16px] uppercase leading-[1.2]",
          subtitle: "font-['TestTiemposText-Regular'] text-[12px] leading-[1] mt-2",
          location: "font-['TestTiemposText-Regular'] text-[12px] leading-[1] mt-2",
          date: "font-['TestTiemposText-Regular'] text-[12px] leading-[1] mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0",
        title: "!font-['TestTiemposText-Regular'] !text-[24px] uppercase !font-normal",
        text: "!font-['TestTiemposText-Regular'] !text-[16px]",
        customShopImage:
          "https://media.werz.at/community-assets/faggotry/faggotry-landing-shop.png",
        customShopImageStyle: "border border-[#000000]",
        sectionTitle: "!mb-4 !sm:mb-6",
      },
    },
    eventV2: {
      container: "flex flex-col",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-8 sm:p-8 p-4 border-b border-[#000000]",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4",
        title:
          "font-['TestTiemposText-Regular'] text-[28px] tracking-[0.04em] uppercase font-normal mb-2",
        subtitle: "font-['TestTiemposText-Regular'] text-[12px] mb-4",
        button: "!w-fit mb-4 sm:mb-0",
        questions: "font-['TestTiemposText-Regular'] text-[12px]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#000000]",
        header:
          "font-['TestTiemposText-Regular'] text-[26px] tracking-[0.04em] uppercase font-normal",
        text: "font-['TestTiemposText-Regular'] text-[12px] w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#000000]",
        header:
          "font-['TestTiemposText-Regular'] text-[26px] tracking-[0.04em] uppercase font-normal",
        text: "font-['TestTiemposText-Regular'] text-[12px] max-w-[652px] w-full",
        map: "sm:w-[350px] w-full h-[206px] overflow-hidden",
        mapPinColor: "#000000",
        mapStrokeColor: "#000000",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header:
          "font-['TestTiemposText-Regular'] text-[26px] tracking-[0.04em] uppercase font-normal",
        text: "font-['TestTiemposText-Regular'] text-[12px] sm:w-[550px]",
      },
      tickets: {
        header:
          "font-['TestTiemposText-Regular'] text-[26px] tracking-[0.04em] uppercase font-normal",
        outerContainer: "flex flex-col sm:p-8 p-4",
        innerContainer: "flex flex-col border border-[#000000] border-b-0 mt-4",
        ticket: {
          container:
            "flex flex-row justify-between gap-4 border-b border-[#000000] p-2 leading-auto tracking-[0.04em]",
          media: "!hidden",
          name: "font-['TestTiemposText-Regular'] text-[14px] uppercase",
          description: "font-['TestTiemposText-Regular'] text-[14px]",
          price: "font-['TestTiemposText-Regular'] text-[14px] uppercase",
          quantity: "font-['TestTiemposText-Regular'] text-[14px] uppercase",
          status: "font-['TestTiemposText-Regular'] text-[14px] text-right",
          counterContainer:
            "border border-[#000000] p-3 bg-[#FFB4E9] !w-fit font-['TestTiemposText-Regular'] text-[14px]",
          button:
            "font-['TestTiemposText-Regular'] text-[14px] border border-[#000000] py-3 px-4 bg-[#FFB4E9] !w-fit",
          plusMinusColor: "#000000",
        },
      },
    },
  },
}

export default faggotryCommunityStyles
